import { Box, Paper, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface SectionCardProps {
  title?: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  /** Extra sx merged onto the Paper */
  sx?: object;
}

/** Glass content block with optional title strip — shared across pages. */
export default function SectionCard({
  title,
  description,
  actions,
  children,
  sx,
}: SectionCardProps) {
  return (
    <Paper sx={{ p: { xs: 2.5, md: 3 }, height: '100%', ...sx }}>
      {(title || actions) && (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: description || title ? 2 : 0,
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            {title && (
              <Typography variant="h6" sx={{ lineHeight: 1.3 }}>
                {title}
              </Typography>
            )}
            {description && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {description}
              </Typography>
            )}
          </Box>
          {actions}
        </Stack>
      )}
      {children}
    </Paper>
  );
}
